"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable import/no-anonymous-default-export,import/no-default-export */
const color_1 = tslib_1.__importDefault(require("./color"));
exports.default = {
    size: {
        xxl: '3rem',
        xl: '2.25rem',
        lg: '1.5rem',
        md: '1.25rem',
        sm: '1rem',
        xs: '.875rem',
        xxs: '.75rem',
    },
    color: {
        base: color_1.default.gray60,
        primary: color_1.default.gray90,
        secondary: color_1.default.gray50,
    },
};
//# sourceMappingURL=font.js.map